/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Result of leaving a team
 * @export
 * @interface TeamLeaveResponse
 */
export interface TeamLeaveResponse {
    /**
     * 
     * @type {boolean}
     * @memberof TeamLeaveResponse
     */
    success: boolean;
    /**
     * Whether the team was disbanded (last member leaving)
     * @type {boolean}
     * @memberof TeamLeaveResponse
     */
    teamDisbanded: boolean;
}

/**
 * Check if a given object implements the TeamLeaveResponse interface.
 */
export function instanceOfTeamLeaveResponse(value: object): value is TeamLeaveResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('teamDisbanded' in value) || value['teamDisbanded'] === undefined) return false;
    return true;
}

export function TeamLeaveResponseFromJSON(json: any): TeamLeaveResponse {
    return TeamLeaveResponseFromJSONTyped(json, false);
}

export function TeamLeaveResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamLeaveResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'teamDisbanded': json['teamDisbanded'],
    };
}

export function TeamLeaveResponseToJSON(json: any): TeamLeaveResponse {
    return TeamLeaveResponseToJSONTyped(json, false);
}

export function TeamLeaveResponseToJSONTyped(value?: TeamLeaveResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'teamDisbanded': value['teamDisbanded'],
    };
}

